import { SignaturePad } from '@/components/ui/SignaturePad/SignaturePad';
import { Skeleton } from '@/components/ui/skeleton';
import { PenLine } from 'lucide-react';
import React from 'react';
import { FieldComponentProps } from './types';

/**
 * View mode: Display signature image or 'No signature' placeholder
 */
const SignatureView = ({ value }: { value?: string | null }) => {
  if (!value) {
    return (
      <div className="text-muted-foreground flex items-center gap-2">
        <PenLine className="h-4 w-4" />
        <span>No signature</span>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-md border bg-white p-2">
      <img src={value} alt="Signature" className="h-auto max-h-48 max-w-full" />
    </div>
  );
};

/**
 * SignatureField component for schema-driven forms
 *
 * - View mode: Displays the signature image or 'No signature' message
 * - Edit mode: Shows a SignaturePad canvas with reset button
 * - Loading mode: Shows a skeleton placeholder
 *
 * Data format: Base64 PNG data URL (e.g., data:image/png;base64,...)
 * Compatible with legacy werkbon signature data.
 */
export const SignatureField: React.FC<FieldComponentProps> = ({
  formMode,
  controllerField,
}) => {
  if (formMode === 'loading') {
    return <Skeleton className="h-[200px] w-full" />;
  }

  if (formMode === 'edit') {
    return (
      <SignaturePad
        width={400}
        height={200}
        onChange={(dataUrl) => {
          controllerField.onChange(dataUrl);
        }}
      />
    );
  }

  return <SignatureView value={controllerField.value} />;
};
